export default __webpack_public_path__ + "static/project-slide-5-415-700-ddc3bdb1983bdf789e5f0e235ccf40fe.webp";